module.exports = __webpack_public_path__ + "media/images/insta-30b19837ef2baece1447c000a494cecc.png";